import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from './../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { Auth } from '../../autentication/Auth';
import { Pacote } from './models/pacote.model';
import { Record } from './models/record';
import { MatTableDataSource } from '@angular/material/table';
import { BaseResult } from '../../shared/models/base.result.model';
import { ExtratoPacote } from './models/extrato-pacote.model';
import { PacoteDetalhes } from './models/pacote-detalhes.model';

@Injectable()
export class RatePackageService {
	private url = endpoints.packagesBankCharges;

	constructor(private http: HttpClient) { }

	getPackage(): Observable<BaseResult<Pacote>> {
		return this.http.get<BaseResult<Pacote>>(this.url.currentPackage);
	}

	getExtract(date: string): Observable<BaseResult<ExtratoPacote[]>> {
		return this.http.get<BaseResult<ExtratoPacote[]>>(`${this.url.extract}/${date}/`);
	}

	getOthersPackages(): Observable<BaseResult<Pacote[]>> {
		return this.http.get<BaseResult<Pacote[]>>(this.url.otherPackages);
	}

	getOtherPackageDetails(cod: number, date: string): Observable<BaseResult<PacoteDetalhes[]>> {
		return this.http.get<BaseResult<PacoteDetalhes[]>>(`${this.url.otherPackagesDetails}/${cod}/servicos?dtVigencia=${date}`);
	}

	hirePackage(codPacote: number, date: string): Observable<any> {
		return this.http.post(this.url.hire, { codPacote: codPacote, dtVigenciaPct: date });
	}

	getTerm(cod: number, date: string) {
		return this.http.get<any>(`${this.url.term}/${cod}/termo?dtVigencia=${date}`);
	}


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/rate-package/rate-package.service.ts